import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';
import { apiRequest } from '../authConfig';

let msalInstance: IPublicClientApplication | null = null;

export const setMsalInstance = (instance: IPublicClientApplication) => {
  msalInstance = instance;
};

export const getAccessToken = async (): Promise<string | null> => {
  if (!msalInstance) {
    console.warn('MSAL instance not initialized');
    return null;
  }

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    return null;
  }

  const account: AccountInfo = msalInstance.getActiveAccount() || accounts[0];

  try {
    // Try to acquire token silently
    const response = await msalInstance.acquireTokenSilent({
      ...apiRequest,
      account: account,
    });
    return response.accessToken;
  } catch (error) {
    console.warn('Silent token acquisition failed, trying interactive', error);
    try {
      // Fallback to interactive token acquisition
      const response = await msalInstance.acquireTokenPopup(apiRequest);
      return response.accessToken;
    } catch (interactiveError) {
      console.error('Interactive token acquisition failed', interactiveError);
      return null;
    }
  }
};
